import { render, staticRenderFns } from "./UIIconInCircle.vue?vue&type=template&id=68ec03ae"
import script from "./UIIconInCircle.vue?vue&type=script&lang=js"
export * from "./UIIconInCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIIcon: require('/storage/data/jenkins/workspace/WEBPLATFORM/FRONTEND/LORGAR/LORGAR_Deploy_Prod/components/ui/UIIcon.vue').default})
